import { createCustomEnum } from "./customEnum";

// Used for old/historical data
const BusinessUnitTypeObsolete = createCustomEnum({
	AMS: { value: 1, name: "ams", displayName: "AMS" },
	AuroraBusinessDevelopment: {
		value: 3,
		name: "aurora_business_development",
		displayName: "Aurora - Business Development",
	},
	AuroraInsideSales: {
		value: 5,
		name: "aurora_inside_sales",
		displayName: "Aurora - Inside Sales",
	},
	Bluesquare: { value: 2, name: "bluesquare", displayName: "Bluesquare" },
	Chosen: { value: 4, name: "chosen", displayName: "Chosen" },
	OnePayment: { value: 6, name: "one_payment", displayName: "One Payment" },
	NailSoft: { value: 7, name: "nail_soft", displayName: "NailSoft" },
});

export default BusinessUnitTypeObsolete;
